import type { RL, RP } from '@/api';
import type { TenantDataScope } from './model';

import { RParam } from '@/api';
import LzdUtil from '@/utils/lzd-util';
import LzdAjax from '@/utils/lzd-ajax';

/** 当前请求API前缀 */
const CURR_API_BASE = '/bsl/tenant/data/scope';
/** 查询租户应用列表 */
async function queryList() {
  return LzdAjax.post<TenantDataScope[]>(
    CURR_API_BASE + '/query/list',
    {},
    true,
    true
  ).then((v) => v.data);
}

/** 查询租户应用列表 */
async function queryPage(data: RP) {
  return LzdAjax.post<RL<TenantDataScope>>(
    CURR_API_BASE + '/manager/query/page',
    data,
    true,
    true
  ).then((v) => v.data);
}

async function insert(data: Partial<TenantDataScope>) {
  return LzdAjax.post(CURR_API_BASE + '/manager/insert', data, true);
}

/** 修改 */
async function update(data: Partial<TenantDataScope>) {
  if (!data || !data.seq) {
    LzdUtil.tipsParameterError();
    return;
  }
  const pks = [data.seq];
  Object.keys(data).forEach((k) => {
    if (
      k.startsWith('created') ||
      k.startsWith('updated') ||
      k.startsWith('deleted') ||
      k === 'version' ||
      k === 'seq' ||
      k === 'tenantId' ||
      k === 'tenantName'
    ) {
      delete data[k];
    }
  });

  return updateBy({
    update: RParam.buildEdit(data),
    pks: pks
  });
}

/** 修改 RP 格式 */
async function updateBy(data: RP) {
  if (!data || !data.update || data.update.length === 0) {
    LzdUtil.tipsParameterError();
    return;
  }
  return LzdAjax.post(CURR_API_BASE + '/manager/update', data, true);
}

/** 删除 */
async function remove(data: Partial<TenantDataScope>) {
  if (!data || !data.seq) {
    LzdUtil.tipsParameterError();
    return;
  }
  return LzdAjax.post(
    CURR_API_BASE + '/manager/delete',
    {
      pks: [data.seq],
      where: []
    },
    true,
    true
  );
}

/** 设置当前学年 */
async function setCurrent(data: Partial<TenantDataScope>) {
  if (!data || !data.seq) {
    LzdUtil.tipsParameterError();
    return;
  }
  return LzdAjax.post(
    CURR_API_BASE + '/manager/current',
    {
      pks: [data.seq],
      where: []
    },
    true,
    true
  );
}

/** 数据作用域(学年) API */
class tenantDataScopeApi {
  static queryPage = queryPage;
  static queryList = queryList;
  static insert = insert;
  static update = update;
  static updateBy = updateBy;
  static remove = remove;
  static setCurrent = setCurrent;
}

export default tenantDataScopeApi;
